const GATEWAY_CONFIG_URL_PARAM_PREFIX = 'gc.';
function getURLParamsGatewayConfigOverrides(search) {
    const urlParams = new URLSearchParams(search);
    const overrides = {};
    for (const [key, value] of urlParams.entries())if (key.startsWith(GATEWAY_CONFIG_URL_PARAM_PREFIX)) {
        const configName = key.slice(3);
        try {
            overrides[configName] = JSON.parse(value);
        } catch (_e) {
            overrides[configName] = value;
        }
    }
    return overrides;
}
function getGatewayConfigOverridesFromEnv() {
    try {
        if ('development' !== process.env.NODE_ENV) return {};
        if ('true' === process.env.SKIP_GATEWAY_CONFIG_OVERRIDES) return {};
        const configStr = process.env.GATEWAY_CONFIG_OVERRIDES;
        return void 0 === configStr ? {} : configStr;
    } catch (e) {
        console.error('Error parsing gateway config override values', e);
        return {};
    }
}
export { GATEWAY_CONFIG_URL_PARAM_PREFIX, getGatewayConfigOverridesFromEnv, getURLParamsGatewayConfigOverrides };

//# sourceMappingURL=gateway-config-overrides.js.map